import styled from "styled-components";
const AdminPersonalQueriesSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;

  height: 90vh;
  padding-top: 10px;
`;

export default AdminPersonalQueriesSc;
